import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AdDirective } from './shared/directives/ad.directive';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { ShelfModule } from './shelf/shelf.module';
import { StoreModule } from './store/store.module';
import { EBEModule } from './EBE/EBE.module';
import { DependentModule } from './shared/dependent.module';
import { PouchdbService } from './shared/pouchDb.service';
import { AlbumModule } from './album/album.module';
import { Component_interactionService } from './component_interaction.service';


@NgModule({
  declarations: [
    AppComponent,
    AdDirective,
    

    
],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ShelfModule,
    StoreModule,
    EBEModule,
    DependentModule,
    AlbumModule
  ],
  providers: [PouchdbService,Component_interactionService
  ],
  bootstrap: [AppComponent],
  entryComponents: []

})
export class AppModule {


  
 }

//  export function getAuthServiceConfigs() {
//   let config = new AuthServiceConfig([
//     {
//       id: GoogleLoginProvider.PROVIDER_ID,
//       provider: new GoogleLoginProvider(
//         '1058901312314-blli9v7q4a2bthrvrvnvrrqn1dtt4ceu.apps.googleusercontent.com'
//       )
//     }
//   ]);
//   return config;
// }

// 1058901312314-blli9v7q4a2bthrvrvnvrrqn1dtt4ceu.apps.googleusercontent.com


// WEBPACK FOOTER //
// ./src/app/app.module.ts